import React, { useRef } from 'react';

const Joystick = ({ canvasRef }) => {

    const joystick = useRef();
    let mousePosition;
    // we manage joystick position with offset
    let offset = [0, 0];
    let isDown, isArrow = false;
    let element = joystick.current;

    const handleDown = (e) => {
        element = joystick.current
        isDown = true;
        isArrow = false;
        offset = [element.offsetLeft - e.clientX, element.offsetTop - e.clientY];
    }

    const handleTop = (e) => {
        element = joystick.current
        isArrow = true;
        isDown = false;
        if (isArrow) mousePosition = { x: e.clientX, y: e.clientY }
        offset = [
            element.offsetLeft - e.clientX,
            element.offsetTop - e.clientY
        ];
        if (e.clientX <= 200 && e.clientX >= 130) mousePosition = { x: e.clientX, y: e.clientY }
        if (e.clientY <= 450 && e.clientY >= 560) mousePosition = { x: e.clientX, y: e.clientY }
        canvasRef.canvas.relativePan({ x: 0, y: mousePosition.y + offset[1] + 50 })
    }

    const handleRight = (e) => {
        element = joystick.current
        isArrow = true;
        isDown = false;
        if (isArrow) mousePosition = { x: e.clientX, y: e.clientY }
        offset = [
            element.offsetLeft - e.clientX,
            element.offsetTop - e.clientY
        ];
        if (e.clientX <= 200 && e.clientX >= 130) mousePosition = { x: e.clientX, y: e.clientY }
        if (e.clientY <= 450 && e.clientY >= 560) mousePosition = { x: e.clientX, y: e.clientY }
        canvasRef.canvas.relativePan({ x: mousePosition.x + offset[0] - 50, y: 0 })
    }

    const handleLeft = (e) => {
        element = joystick.current
        isArrow = true;
        isDown = false;
        if (isArrow) mousePosition = { x: e.clientX, y: e.clientY }
        offset = [
            element.offsetLeft - e.clientX,
            element.offsetTop - e.clientY
        ];
        if (e.clientX <= 200 && e.clientX >= 130)
            mousePosition = { x: e.clientX, y: e.clientY }
        if (e.clientY <= 450 && e.clientY >= 560)
            mousePosition = { x: e.clientX, y: e.clientY }
        canvasRef.canvas.relativePan({ x: mousePosition.x + offset[0] + 50, y: 0 })
    }

    const handleBottom = (e) => {
        element = joystick.current
        isArrow = true;
        isDown = false;
        if (isArrow) mousePosition = { x: e.clientX, y: e.clientY }
        offset = [
            element.offsetLeft - e.clientX,
            element.offsetTop - e.clientY
        ];
        if (e.clientX <= 200 && e.clientX >= 130) mousePosition = { x: e.clientX, y: e.clientY }
        if (e.clientY <= 450 && e.clientY >= 560) mousePosition = { x: e.clientX, y: e.clientY }
        canvasRef.canvas.relativePan({ x: 0, y: mousePosition.y + offset[1] - 50 })
    }

    document.addEventListener('mouseup', function () {
        if (!joystick.current) return;
        isDown = false;
        joystick.current.style.left = "4.5px";
        joystick.current.style.top = "4.5px";
        joystick.current.style.transition = ".1s ease-in-out";
    }, true);

    document.addEventListener('mousemove', function (e) {
        e.preventDefault();
        if (isDown) {
            if (e.clientX <= 200 && e.clientX >= 130) {
                mousePosition = {
                    x: e.clientX,
                    y: e.clientY
                }
            }
            if (e.clientY <= 450 && e.clientY >= 560) {
                mousePosition = {
                    x: e.clientX,
                    y: e.clientY
                }
            }
            element.style.left = (mousePosition.x + offset[0]) + 'px';
            element.style.top = (mousePosition.y + offset[1]) + 'px';
            canvasRef.canvas.relativePan({ x: mousePosition.x + offset[0], y: mousePosition.y + offset[1] })
        }
    }, true);

    return (
        <>
            <div className="rde-joystick">
                <div className="rde-joystick-control">
                    <div className="rde-joystick-control-top" onClick={handleTop}></div>
                    <div className="rde-joystick-control-left" onClick={handleLeft}></div>
                    <div className="rde-joystick-control-joy">
                        {/* <div ref={joystick} className="joy" onMouseDown={handleDown} style={{ position: "absolute", left: "9px", top: "9px" }}></div> */}
                        <div ref={joystick} className="joy" style={{ position: "absolute", left: "4.5px", top: "4.5px" }}></div>
                    </div>
                    <div className="rde-joystick-control-right" onClick={handleRight}></div>
                    <div className="rde-joystick-control-bottom" onClick={handleBottom}></div>
                </div>
            </div>
        </>
    );
}

export default Joystick;
